export const allCompanyTypes = ["Production", "Demo", "Template", "Training", "Sandbox"] as const;
export type CompanyType = (typeof allCompanyTypes)[number];

export type ClientType = "FundAdmin" | "FundManager";
